export const incomeTypes: {
  id: string;
  label: string;
  default?: boolean;
}[] = [
  {
    id: "INCOME_JOB",
    label: "Job",
    default: true,
  },
  {
    id: "INCOME_SIDE_JOB",
    label: "Side Job",
    default: true,
  },
  {
    id: "INCOME_GIFT",
    label: "Gift",
    default: true,
  },
];
